<template>
  <div class="tw:bg-white">
    <ContainerLayout class="tw:flex tw:flex-col">
      <div
        v-for="point in points"
        :key="point.id"
        class="tw:mx-4 tw:flex tw:flex-col tw:md:flex-row tw:gap-y-6 tw:gap-x-8 tw:items-center tw:my-[60px]"
      >
        <div class="tw:flex tw:flex-col tw:items-start tw:gap-y-2 tw:w-full tw:md:w-1/2">
          <span class="tw:bg-green-200 tw:rounded-lg tw:font-bold tw:px-2 tw:py-1">{{ $t(point.badge) }}</span>
          <h3 class="tw:font-bold tw:text-[28px]">{{ $t(point.title) }}</h3>
          <p>{{ $t(point.text) }}</p>
        </div>
        <div class="tw:flex tw:justify-end tw:w-full tw:md:w-1/2">
          <img :src="point.img" :alt="$t(point.badge)" class="tw:w-full tw:sm:w-4/5" />
        </div>
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import { useIsMobile } from '@/composables/useIsMobile'

const { screenWidth } = useIsMobile()
const screenSize = ref(screenWidth.value > 768 ? 'm' : 's')

const guideImages = import.meta.glob('/src/assets/img/rate-connect/guide-images/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
})

const AnalyticsImg = computed(() => {
  const path = `/src/assets/img/rate-connect/guide-images/rate_connect_analytics_${screenSize.value}.png`

  return guideImages[path]
})

const ActivityImg = computed(() => {
  const path = `/src/assets/img/rate-connect/guide-images/rate_connect_activity_${screenSize.value}.png`
  return guideImages[path]
})

const OpportunitiesImg = computed(() => {
  const path = `/src/assets/img/rate-connect/guide-images/rate_connect_opportunities_${screenSize.value}.png`
  return guideImages[path]
})

watch(screenWidth, newSize => {
  if (newSize > 768) {
    screenSize.value = 'm'
  } else {
    screenSize.value = 's'
  }
})

const points = ref([
  {
    id: 'analytics',
    badge: 'rc_product_page_analytics',
    title: 'rc_product_page_performance',
    text: 'rc_product_page_performance_text',
    img: AnalyticsImg,
  },
  {
    id: 'activity',
    badge: 'rc_product_page_activity',
    title: 'rc_product_page_booking_details',
    text: 'rc_product_page_booking_details_text',
    img: ActivityImg,
  },
  {
    id: 'opportunities',
    badge: 'rc_product_page_opportunities',
    title: 'rc_product_page_top_opportunities_header',
    text: 'rc_product_page_top_opportunities_text',
    img: OpportunitiesImg,
  },
])
</script>
